import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass(["menu-btn", { 'menu-btn--close': _ctx.isActive }])
  }, [
    _createVNode(_component_SvgIcon, {
      local: "",
      class: "icon",
      src: _ctx.hamburgerIcon
    }, null, 8, ["src"])
  ], 2))
}